/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';
import {Envelope} from '@app/modules/operations-api/models/envelope';
import {JobsJob} from '@app/modules/operations-api/models/jobs-job';
import {JobView} from '@models/JobView';
import {Lookup} from '@models/lookup';

@Injectable({
  providedIn: 'root',
})
class EngineerService extends __BaseService {
  static readonly EngineerGetEngineerJobsPath = '/api/engineer/jobs';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return OK
   */
  EngineerGetEngineerJobsResponse(): __Observable<__StrictHttpResponse<Envelope<JobView[]>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/engineer/jobs`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<JobView[]>>;
      })
    );
  }
  /**
   * @return OK
   */
  EngineerGetEngineerJobs(): __Observable<Envelope<JobView[]>> {
    return this.EngineerGetEngineerJobsResponse().pipe(
      __map(_r => _r.body as Envelope<JobView[]>)
    );
  }
}

module EngineerService {
}

export { EngineerService }
